// @flow
import { handleActions } from 'redux-actions';

import * as actions from './actions';
import { mkPayeeListStore } from './types';

const reducer = handleActions({

  [actions.updatePayeeListAsync]: (state, data) => {
    setTimeout(() => {
      data.asyncDispatch(actions.updatePayeeList(data.payload));
    }, 2500);
    return state;
  },

  [actions.updatePayeeList]: (state) => state,

  [actions.updatePayeeListSuccess]: (state, { payload: data }) => upsertResources(state, data),

  [actions.updatePayeeListFailure]:
    (state, { payload: _error }) => state,

}, mkPayeeListStore());

export const REDUCER_KEY = 'payeeListStore';
export default reducer;


export function upsertResources(state, resourcesById) {

  let resources = state.resourcesById;

  resourcesById.forEach((res, key) => {
    resources = resources.set(key, res);
  });

  return state.set('resourcesById', resources).set('loadPending', false);
}
